/**
 * Підписи гарячих клавіш і вбудованих команд палітри (UX-10…12). Їх реєструє перший екран
 * (оболонка, список, «Сьогодні», картка), а показують шпаргалка й палітра. Не входить у
 * зведений `uk.ts`: його тягне документ входу, а клавіш там немає. Тексти самих вікон палітри й
 * шпаргалки — `uk/palette.ts` (лише лінивий чанк).
 */
export const keys = {
  keyPalette: 'Пошук і команди',
  /** Поле палітри: поки немає провайдерів пошуку записів (E5) — лише команди й розділи. */
  keyPaletteCommands: 'Команда або розділ',
  keyPaletteRecords: 'Ім’я, телефон, email або команда',
  /** Закрити палітру на телефоні, де немає Esc. */
  keyPaletteCancel: 'Скасувати',
  keyCheatsheet: 'Шпаргалка клавіш',
  keyCheatsheetWords: ['гарячі клавіші', 'клавіатура', 'довідка', 'shortcuts'],
  keyFocusToday: 'Фокус у панель «Сьогодні»',
  keyToasts: 'Перейти до повідомлень',
  keyGoMail: 'Пошта',

  keyRowNext: 'Наступний / попередній рядок',
  keyRowEdge: 'Перший / останній рядок',
  keyRowPage: 'На екран вище / нижче',
  keyOpen: 'Відкрити картку',
  keyOpenNewTab: 'Відкрити картку в новій вкладці',
  keyRowExtend: 'Розширити вибір вниз / вгору',
  keySelectAllLoaded: 'Обрати всі завантажені',
  keyRowSelect: 'Обрати рядок',
  keyCall: 'Подзвонити',
  keyLog: 'Записати результат',
  keyClearSelection: 'Зняти вибір',
  keyTaskNext: 'Наступна / попередня задача',
  keyTaskDone: 'Виконати задачу',
  keyTaskDoneOutcome: 'Виконати з результатом',
  keyTaskSnooze: 'Перенести задачу',

  menuKeyHints: 'Підказки клавіш у кнопках і меню',
  /** Порада після третього відкриття палітри мишею (UX-12). */
  paletteTip: (combo: string) => `Палітра відкривається клавішами ${combo}`,
} as const;
